import React, { useState } from 'react';
import {
  string, arrayOf, shape, func, node, number
} from 'prop-types';
import { Tab, Tabs } from '@one-thd/sui-atomic-components';

export const TabContent = ({ id, items, buildDrawer }) => {

  const [tabValues, setTabValues] = useState({});

  function TabPanel(props) {
    const { children, value, index } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
      >
        {value === index && (
          <div className="sui-pt-6">
            <div>{children}</div>
          </div>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: node.isRequired,
    index: number.isRequired,
    value: number.isRequired,
  };

  const handleTabChange = (tabId, newValue) => {
    setTabValues((prev) => ({
      ...prev,
      [tabId]: newValue,
    }));
  };

  const activeTab = tabValues[id] || 0;

  return (
    <div className="sui-w-full" key={id}>
      <Tabs
        value={activeTab}
        onChange={(event, newValue) => handleTabChange(id, newValue)}
        variant="fullWidth"
      >
        {items.map((tab, index) => (
          <Tab
            key={tab.id}
            label={tab.label}
            id={`simple-tab-${index}`}
            aria-controls={`simple-tabpanel-${index}`}
          />
        ))}
      </Tabs>
      {items.map((tab, index) => (
        <TabPanel
          key={tab.id}
          value={activeTab}
          index={index}
        >
          {buildDrawer(tab.content, index + 1)}
        </TabPanel>
      ))}
    </div>
  );
};

TabContent.propTypes = {
  id: string.isRequired,
  items: arrayOf(shape()).isRequired,
  buildDrawer: func.isRequired
};